angular.module('tasks.meeting-attendance')
    .component('taskMeetingAttendance', {
        bindings: {
            taskId: '<'
        },
        templateUrl: 'app/task/meeting-attendance/task-meeting-attendance.html',
        controller: function ($scope, TaskMeetingAttendanceService, TaskMeetingAttendance, Principal){
            this.TaskMeetingAttendanceService = TaskMeetingAttendanceService;

            this.$onInit = () => {
                this.canAnswerForAllUsers = Principal.hasAnyAuthority(["ROLE_TASKS_SUPERUSER"])
                Principal.currentUser().then(user => this.currentUser = user)
                TaskMeetingAttendance.query({id: this.taskId}).$promise.then(result => this.items = result)
            }

            this.accept = () => {
                return TaskMeetingAttendanceService.accept(this.taskId)
            }
            this.note = () => {
                return TaskMeetingAttendanceService.note(this.taskId)
            }
            this.reject = () => {
                return TaskMeetingAttendanceService.reject(this.taskId)
            }

            $scope.$on('task.updated', () => this.$onInit());
            $scope.$on('task.deleted', () => this.$onInit());
        }
    })
